module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-og-64be403fc577c59bc3431d9b097e7c69.jpg";